<template>
  <div>
    <router-link
      :to="`/subscription?page=${getPages}&currentPage=${curPage}`"
      tag="p"
      class="dashboard__back"
      >Back</router-link
    >
    <div class="dashboard__booking-profile" v-if="subscriptionData">
      <div
        class="dashboard__booking-profile-img"
        :style="{
          backgroundImage:
            'url(' + subscriptionData.user_kyc.userKyc.photo + ')'
        }"
      ></div>
      <div class="dashboard__booking-profile-detail">
        <p class="dashboard__booking-profile-name">
          {{
            `${subscriptionData.user_kyc.userKyc.firstname} ${subscriptionData.user_kyc.userKyc.lastname} `
          }}
        </p>
        <p class="dashboard__booking-profile-membership">
          Member since {{ formatDate(subscriptionData.user_kyc.createdAt) }}
        </p>
        <p class="dashboard__booking-profile-age">
          {{ subscriptionData.user_kyc.userKyc.gender }}
        </p>
        <p class="dashboard__booking-profile-employment">
          {{ subscriptionData.user_kyc.employment_status }}
        </p>
        <p class="dashboard__booking-profile-employment">
          {{ subscriptionData.user_kyc.userKyc.phone }}
        </p>
        <p
          class="dashboard__bookingDetail-status"
          :class="[
            { 'text-warning': subscriptionData.status == 'pending' },
            { 'text-danger': subscriptionData.status == 'canceled' },
            { 'text-success': subscriptionData.status == 'active' },
            { 'text-success': subscriptionData.status == 'paid' },
            { 'text-danger': subscriptionData.status == 'expired' },
            { 'text-danger': subscriptionData.status == 'inactive' }
          ]"
        >
          {{ subscriptionData.status | capitalize }}
        </p>
      </div>

      <div
        class="
          form__action
          dashboard__booking-profile-action dashboard__manageListing-action
        "
      >
        <div class="form__action-wrap">
          <button
            type="button"
            class="cta_btn dashboard__booking-profile-approve"
            @click="toggleExtraChargeModal(null)"
          >
            <svgicon
              icon="spinner"
              v-if="extraChargeLoader"
              class="button__loader"
            ></svgicon>
            Add Extra Charge
          </button>
          <button
            type="button"
            class="cta_btn dashboard__booking-profile-reactivate"
            v-if="subscriptionData.status == 'expired'"
            @click="toggleReactivateSubModal"
          >
            <svgicon
              icon="spinner"
              v-if="extraChargeLoader"
              class="button__loader"
            ></svgicon>
            Reactivate subscription
          </button>
          <b-dropdown
            id="dropdown-right"
            right
            toggle-class="text-decoration-none alt_btn"
            no-caret
            v-if="subscriptionData.status != 'canceled'"
          >
            <template v-slot:button-content class="alt_btn">
              <svgicon
                icon="spinner"
                v-if="dropdownLoader"
                class="button__loader_red"
              ></svgicon>
              <svgicon
                icon="table-menu"
                class="dashboard__manageListing-action-icon"
                v-if="!dropdownLoader"
              ></svgicon>
            </template>
            <b-dropdown-item-button @click="toggleManageSub"
              >Manage subscription</b-dropdown-item-button
            >
            <b-dropdown-item-button @click="toggleCancelSubWarningModal"
              >Cancel subscription</b-dropdown-item-button
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="dashboard__booking" v-if="subscriptionData">
      <div class="dashboard__manageListing-individual-header">
        <p class="dashboard__manageListing-individual-heading">
          Subscription Details
        </p>
        <p class="dashboard__manageListing-individual-heading">Action</p>
      </div>
      <div class="dashboard__booking-space">
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Space name</p>
          <p
            class="
              dashboard__booking-space-info-text
              dashboard__manageListing-individual-location
            "
            :class="[manageSubscription ? 'dashboard__manage-spacer' : '']"
            @click="showMap"
          >
            {{ subscriptionData.space_name }}
          </p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Subcription type</p>
          <div class="dashboard__manage">
            <p class="dashboard__booking-space-info-text">
              {{ subscriptionData.sub_type }} |
              {{ subscriptionData.sub_plan | capitalize }}
            </p>
            <select
              v-model="manageSubForm.sub_plan"
              v-if="manageSubscription"
              class="dashboard__select sub-select"
            >
              <option v-for="item in subscriptionData.listingSubPlan" :key="item.id" :value="item.plan">{{ item.plan  }}</option>
            </select>
          </div>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Price</p>
          <p
            class="
              dashboard__booking-space-info-text
              dashboard__manageListing-individual-location
            "
            :class="[manageSubscription ? 'dashboard__manage-spacer' : '']"
            @click="togglePricingBreakdownModal"
            v-html="totalRent"
          ></p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">
            Security deposit days
          </p>
          <div class="dashboard__manage">
            <p class="dashboard__booking-space-info-text">
              {{ subscriptionData.security_days }}
            </p>
            <input
              v-model.number="manageSubForm.security_days"
              v-if="manageSubscription"
              class="dashboard__input sub-input"
              type="number"
              min="0"
              max="7"
              pattern="^([1-7])$"
              placeholder="Enter a number"
            />
          </div>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">
            Rent Default Security deposit
          </p>
          <div class="dashboard__manage">
            <p
              class="dashboard__booking-space-info-text"
              v-html="
                formatAmount(
                  subscriptionData.security_deposit_bal,
                  currentPriceTemplate.currency
                )
              "
            ></p>
            <input
              v-model.number="manageSubForm.security_deposit_bal"
              v-if="manageSubscription"
              class="dashboard__input sub-input"
              type="number"
              min="0"
              placeholder="Enter an amount"
            />
          </div>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">
            Damages Security deposit
          </p>
          <p
            class="dashboard__booking-space-info-text"
            :class="[manageSubscription ? 'dashboard__manage-spacer' : '']"
            v-html="
              formatAmount(
                subscriptionData.eviction_security_deposit,
                currentPriceTemplate.currency
              )
            "
          ></p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Start date</p>
          <p
            class="dashboard__booking-space-info-text"
            :class="[manageSubscription ? 'dashboard__manage-spacer' : '']"
          >
            {{ formatDate(subscriptionData.start_date) }}
          </p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">
            {{
              subscriptionData.sub_plan == "daily" ? "End date" : "Renewal date"
            }}
          </p>
          <div class="dashboard__manage"
          >
            <p
              class="dashboard__booking-space-info-text"
              :class="[manageSubscription ? 'dashboard__spacer' : '']"
            >
              {{ formatDate(subscriptionData.end_date) }}
            </p>
            <div  v-if="manageSubscription"
               class="dashboard__manage__space">
              <button
                class="dashboard__date-button"
                @click="openDateModal"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 12C2 8.229 2 6.343 3.172 5.172C4.344 4.001 6.229 4 10 4H14C17.771 4 19.657 4 20.828 5.172C21.999 6.344 22 8.229 22 12V14C22 17.771 22 19.657 20.828 20.828C19.656 21.999 17.771 22 14 22H10C6.229 22 4.343 22 3.172 20.828C2.001 19.656 2 17.771 2 14V12Z"
                    stroke="#2E48DA"
                    stroke-width="1.5"
                  />
                  <path
                    d="M7 4V2.5M17 4V2.5M2.5 9H21.5"
                    stroke="#2E48DA"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M18 17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18C16.7348 18 16.4804 17.8946 16.2929 17.7071C16.1054 17.5196 16 17.2652 16 17C16 16.7348 16.1054 16.4804 16.2929 16.2929C16.4804 16.1054 16.7348 16 17 16C17.2652 16 17.5196 16.1054 17.7071 16.2929C17.8946 16.4804 18 16.7348 18 17ZM18 13C18 13.2652 17.8946 13.5196 17.7071 13.7071C17.5196 13.8946 17.2652 14 17 14C16.7348 14 16.4804 13.8946 16.2929 13.7071C16.1054 13.5196 16 13.2652 16 13C16 12.7348 16.1054 12.4804 16.2929 12.2929C16.4804 12.1054 16.7348 12 17 12C17.2652 12 17.5196 12.1054 17.7071 12.2929C17.8946 12.4804 18 12.7348 18 13ZM13 17C13 17.2652 12.8946 17.5196 12.7071 17.7071C12.5196 17.8946 12.2652 18 12 18C11.7348 18 11.4804 17.8946 11.2929 17.7071C11.1054 17.5196 11 17.2652 11 17C11 16.7348 11.1054 16.4804 11.2929 16.2929C11.4804 16.1054 11.7348 16 12 16C12.2652 16 12.5196 16.1054 12.7071 16.2929C12.8946 16.4804 13 16.7348 13 17ZM13 13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13C11 12.7348 11.1054 12.4804 11.2929 12.2929C11.4804 12.1054 11.7348 12 12 12C12.2652 12 12.5196 12.1054 12.7071 12.2929C12.8946 12.4804 13 12.7348 13 13ZM8 17C8 17.2652 7.89464 17.5196 7.70711 17.7071C7.51957 17.8946 7.26522 18 7 18C6.73478 18 6.48043 17.8946 6.29289 17.7071C6.10536 17.5196 6 17.2652 6 17C6 16.7348 6.10536 16.4804 6.29289 16.2929C6.48043 16.1054 6.73478 16 7 16C7.26522 16 7.51957 16.1054 7.70711 16.2929C7.89464 16.4804 8 16.7348 8 17ZM8 13C8 13.2652 7.89464 13.5196 7.70711 13.7071C7.51957 13.8946 7.26522 14 7 14C6.73478 14 6.48043 13.8946 6.29289 13.7071C6.10536 13.5196 6 13.2652 6 13C6 12.7348 6.10536 12.4804 6.29289 12.2929C6.48043 12.1054 6.73478 12 7 12C7.26522 12 7.51957 12.1054 7.70711 12.2929C7.89464 12.4804 8 12.7348 8 13Z"
                    fill="#2E48DA"
                  />
                </svg>
              </button>  
              <p 
               class="dashboard__booking-space-info-text">
                {{ formatDate(date) }}
              </p>
            </div>
          </div>
        </div>
        <div v-if="manageSubscription" class="dashboard__manage_button">
          <button
            type="button"
            class="cta_btn dashboard__booking-profile-approve"
            @click="manageSub"
          >
            <svgicon
              icon="spinner"
              v-if="manageLoader"
              class="button__loader"
            ></svgicon>
            Save Changes
          </button>
        </div>
      </div>
    </div>

    <div class="dashboard__tab">
      <b-tabs>
        <b-tab title="Extra Charges" v-if="subscriptionData" active>
          <div class="dashboard__table-search-wrap">
            <svgicon
              icon="search"
              class="dashboard__table-search-icon"
            ></svgicon>
            <input
              v-model="search"
              placeholder="Search"
              class="listing__input dashboard__table-search"
            />
          </div>

          <div
            class="dashboard__payment-history-wrap dashboard__overview-table"
          >
            <table class="dashboard__payment-history-table">
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading">DATE</th>

                  <th class="dashboard__payment-history-table-heading">type</th>
                  <th class="dashboard__payment-history-table-heading">
                    Amount
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Status
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Payment Status
                  </th>
                  <th class="dashboard__payment-history-table-heading"></th>
                  <th class="dashboard__payment-history-table-heading"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(extraCharge, index) in sortExtraCharge"
                  :key="index"
                  class="dashboard__table-row"
                >
                  <td class="dashboard__payment-history-table-data">
                    {{ formatDate(extraCharge.created_at) }}
                  </td>

                  <td class="dashboard__payment-history-table-data">
                    <p>{{ extraCharge.extracharge_type }}</p>

                    <p>{{ extraCharge.narration }}</p>
                  </td>
                  <td
                    class="dashboard__payment-history-table-data"
                    v-html="
                      formatAmount(
                        extraCharge.amount,
                        currentPriceTemplate.currency
                      )
                    "
                  ></td>
                  <td class="dashboard__payment-history-table-data">
                    <span
                      class="dashboard__payment-history-table-status"
                      :class="[
                        { pending: extraCharge.status == 'Pending' },
                        { approve: extraCharge.status == 'Approved' },
                        { decline: extraCharge.status == 'Declined' },
                        { decline: extraCharge.status == 'Retracted' },
                        { decline: extraCharge.status == 'Deleted' }
                      ]"
                      >{{ extraCharge.status }}</span
                    >
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <span
                      class="dashboard__payment-history-table-status"
                      :class="[
                        { pending: extraCharge.payment_status == 'pending' },
                        { approve: extraCharge.payment_status == 'success' },
                        { decline: extraCharge.payment_status == 'declined' }
                      ]"
                      >{{
                        extraCharge.payment_status == "success"
                          ? "paid"
                          : extraCharge.payment_status | capitalize
                      }}</span
                    >
                  </td>
                  <td class="dashboard__payment-history-table-data">
                    <a :href="extraCharge.doc_file_path" target="_blank">
                      <svgicon
                        icon="view"
                        class="dashboard__payment-history-resp-download-icon"
                        style="cursor: pointer"
                      ></svgicon>
                    </a>
                  </td>
                  <td
                    class="
                      dashboard__payment-history-table-data
                      dashboard__listing-table
                    "
                  >
                    <b-dropdown
                      id="dropdown-left"
                      size="lg"
                      variant="link"
                      toggle-class="text-decoration-none"
                      no-caret
                      v-if="
                        extraCharge.status !== 'Approved' ||
                          extraCharge.payment_status !== 'success'
                      "
                    >
                      <template v-slot:button-content>
                        <svgicon
                          icon="table-menu"
                          class="dashboard__listing-table-menu"
                        ></svgicon>
                      </template>
                      <b-dropdown-item
                        v-if="
                          (extraCharge.status == 'Pending' ||
                            extraCharge.status == 'Declined') &&
                            extraCharge.action_by === 'admin'
                        "
                        @click="toggleExtraChargeModal(extraCharge.id)"
                        >Edit</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="
                          extraCharge.status == 'Pending' ||
                            extraCharge.status == 'Declined'
                        "
                        @click="
                          toggleExcessChargeWarningModal(
                            extraCharge.id,
                            'approve'
                          )
                        "
                        >Approve</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="extraCharge.status == 'Pending'"
                        @click="toggleDeclineModal(extraCharge.id)"
                        >Decline</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="
                          extraCharge.status == 'Approved' &&
                            extraCharge.payment_status == 'pending'
                        "
                        @click="toggleMarkExtraPaidModal(extraCharge.id)"
                        >Mark as paid</b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="extraCharge.status == 'Retracted'"
                        @click="toggleRetractionModal(extraCharge.deleteReason)"
                        >Retraction reason</b-dropdown-item
                      >
                      <b-dropdown-item
                        @click="toggleDeleteExtraChargeModal(extraCharge.id)"
                        >Delete</b-dropdown-item
                      >
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <!-- Price breakdown modals -->
    <AppModal
      :show="showPricingBreakdownModal"
      :showOkButton="true"
      okButtonText="Ok"
      @onapprove="togglePricingBreakdownModal"
      @onclosed="showPricingBreakdownModal = false"
    >
      <p class="warning__title">Price breakdown</p>
      <p class="warning__decline-reason" v-html="totalRent"></p>
      <div class="priceSummary__breakdown">
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">Rent</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                currentPriceTemplate.amount,
                currentPriceTemplate.currency
              )
            "
          ></p>
        </div>
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">Commission</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                currentPriceTemplate.computed_commission,
                currentPriceTemplate.currency
              )
            "
          ></p>
        </div>
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">VAT</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                currentPriceTemplate.vat,
                currentPriceTemplate.currency
              )
            "
          ></p>
        </div>
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">Withholding tax</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                currentPriceTemplate.withholdingTax,
                currentPriceTemplate.currency
              )
            "
          ></p>
        </div>
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">Service charge</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                currentPriceTemplate.service_charge,
                currentPriceTemplate.currency
              )
            "
          ></p>
        </div>
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">Discount</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                '-' + currentPriceTemplate.discount,
                currentPriceTemplate.currency
              )
            "
          ></p>
        </div>
      </div>
    </AppModal>

    <!-- Map modal -->
    <AppModal
      :show="showMapModal"
      :showCancelBtn="true"
      cancelBtnText="Cancel"
      @oncancel="showMapModal = false"
      @onclosed="showMapModal = false"
    >
      <div id="map" class="location__map w-100"></div>
    </AppModal>

    <!-- Cancel subscription -->
    <AppModal
      :show="showCancelSubWarningModal"
      :showOkButton="true"
      :showCancelBtn="true"
      okButtonText="Yes"
      cancelBtnText="No"
      @oncancel="showCancelSubWarningModal = false"
      @onapprove="cancelSub"
      @onclosed="showCancelSubWarningModal = false"
    >
      <p class="warning__title">Cancel member subscription</p>

      <p class="warning__text" v-if="subscriptionData">
        Are you sure you want to cancel
        <strong>{{ subscriptionData.user_kyc.fullname }}</strong> subscription?
      </p>
    </AppModal>

    <!-- Reactivate subscription -->
    <AppModal
      :show="showReactivateModal"
      :showOkButton="true"
      :showCancelBtn="true"
      okButtonText="Yes"
      cancelBtnText="No"
      @oncancel="showReactivateModal = false"
      @onapprove="reactivateSub"
      @onclosed="showReactivateModal = false"
      :loader=reactivateLoader
    >
      <p class="warning__title">Reactivate member subscription</p>

      <p class="warning__text" v-if="subscriptionData">
        Are you sure you want to reactivate
        <strong>{{ subscriptionData.user_kyc.fullname }}</strong> subscription?
      </p>
    </AppModal>

    <!-- Retracting reason modal -->
    <AppModal
      :show="showRetractionModal"
      :showOkButton="true"
      okButtonText="Okay"
      @onapprove="showRetractionModal = false"
      @onclosed="showRetractionModal = false"
    >
      <p class="warning__title">Retracting reason</p>

      <p class="warning__text">
        {{ retractionReason }}
      </p>
    </AppModal>

    <!-- extra charge modal -->
    <AppModal
      :show="showExtraChargeModal"
      @onclosed="showExtraChargeModal = false"
      :styleGotten="{ 'max-width': '700px' }"
    >
      <p class="warning__title mb-5">
        {{ editExtraCharge ? "Edit" : "Add" }} Extra Charge
      </p>

      <div class="dashboard__manageListing-extraCharge-row">
        <div class="form__group">
          <label for class="form__label">Select type of charge</label>
          <select
            class="dashboard__select"
            v-model="extraChargeData.extracharge_type"
            required
          >
            <option :value="null" disabled selected>Select an option</option>
            <option
              v-for="(excessChargeOption,
              index) in subscriptionSetup.extra_charge_types"
              :key="index"
              :value="excessChargeOption.title"
            >
              {{ excessChargeOption.title }}
            </option>
          </select>
        </div>

        <div class="form__group">
          <label for class="form__label">Amount</label>
          <cleave
            v-model="extraChargeData.amount"
            :placeholder="
              currentPriceTemplate && currentPriceTemplate.currency === 'GHS'
                ? '¢ 0'
                : '₦ 0'
            "
            class="dashboard__input"
            :options="currency"
          ></cleave>
        </div>

        <div class="form__group">
          <label for class="form__label">Add proof of charge</label>
          <b-form-file
            :file-name-formatter="formatAttachmentNames"
            size="lg"
            @change="docPreUpload"
            placeholder="Choose a file"
          ></b-form-file>
        </div>

        <div class="form__group">
          <label for class="form__label">Notes</label>
          <textarea
            class="
              listing__textarea
              dashboard__manageListing-extraCharge-textarea
            "
            v-model="extraChargeData.narration"
          ></textarea>
        </div>

        <div
          class="extraChargeReceipt"
          v-if="editExtraCharge"
          :style="{
            backgroundImage: 'url(' + extraChargeData.doc_file_path + ')'
          }"
        ></div>
      </div>
      <button
        class="cta_btn ml-auto dashboard__btn"
        @click="toggleExtraChargeWarningModal"
      >
        {{ editExtraCharge ? "Edit charge" : "Add Charge" }}
      </button>
    </AppModal>

    <!-- extra charge warning modal -->
    <AppModal
      :show="showExtraChargeWarningModal"
      :showOkButton="true"
      :showCancelBtn="true"
      okButtonText="Yes"
      cancelBtnText="No"
      @oncancel="toggleExtraChargeWarningModal"
      @onapprove="addExtracharge"
      @onclosed="showExtraChargeWarningModal = false"
    >
      <p class="warning__title">
        {{ editExtraCharge ? "Edit" : "Add" }} Extra Charge
      </p>

      <p class="warning__text" v-if="editExtraCharge">
        Your extra charge will be edited. Do you want to proceed with this?
      </p>
      <p class="warning__text" v-else>
        Your extra charge will be added to the listing. Do you want to proceed
        with this?
      </p>
    </AppModal>

    <!-- extra charge mark paid warning modal -->
    <AppModal
      :show="showMarkExtraPaidWarningModal"
      :showOkButton="true"
      :showCancelBtn="true"
      okButtonText="Yes"
      cancelBtnText="No"
      @oncancel="showMarkExtraPaidWarningModal = false"
      @onapprove="markExtraChargePaid"
      @onclosed="showMarkExtraPaidWarningModal = false"
    >
      <p class="warning__title">Mark extra charge as paid</p>

      <p class="warning__text" v-if="subscriptionData">
        Are you sure you want to mark
        <strong>{{ subscriptionData.user_kyc.fullname }}</strong> extra charge
        as paid?
      </p>
    </AppModal>

    <AppModal
      :show="showDeclineOptionModal"
      @onclosed="showDeclineOptionModal = false"
    >
      <p class="warning__title">Decline this excess charge?</p>
      <p class="warning__decline-reason">
        You’re declining this excess charge because:
      </p>
      <div class="form__group">
        <label for class="form__label">Reason</label>
        <textarea
          class="dashboard__textarea"
          row="5"
          name="others"
          v-model="reason"
        ></textarea>
      </div>

      <div class="bedroom__preview-action">
        <button class="warning__cancel" @click="toggleDeclineModal">
          Cancel
        </button>
        <button
          class="warning__delete"
          :disabled="reason == null"
          @click="toggleExcessChargeWarningModal(excessChargeId, 'decline')"
        >
          Decline
        </button>
      </div>
    </AppModal>

    <!-- extra charge warning modal -->
    <AppModal
      :show="showExcessChargeWarning"
      :showOkButton="true"
      :showCancelBtn="true"
      okButtonText="Yes"
      cancelBtnText="No"
      @oncancel="
        (showExcessChargeWarning = false),
          (declineAction = false),
          (approveAction = false)
      "
      @onapprove="excessAction"
      @onclosed="showExcessChargeWarning = false"
    >
      <p class="warning__title" v-if="declineAction">Decline excess charge</p>
      <p class="warning__title" v-if="approveAction">Approve excess charge</p>

      <p class="warning__text" v-if="declineAction">
        Are you sure you want to decline this excess charge?
      </p>
      <p class="warning__text" v-if="approveAction">
        Are you sure you want to approve this excess charge?
      </p>
    </AppModal>

    <!-- Delete extra charge modal -->
    <AppModal
      :show="showDeleteExtraChargeModal"
      @onclosed="showDeleteExtraChargeModal = false"
    >
      <p class="warning__title mb-5">Delete Extra Charge</p>

      <div class="form__group">
        <label for class="form__label">Reason for deleting</label>
        <textarea
          class="listing__textarea mb-0 full__width"
          v-model="deleteExtraChargeReason"
        ></textarea>
      </div>
      <div class="bedroom__preview-action">
        <button
          class="warning__cancel"
          @click="showDeleteExtraChargeModal = false"
        >
          Cancel
        </button>
        <button
          class="warning__delete btn_disabled"
          :disabled="!deleteExtraChargeReason"
          @click="deleteExtraCharge"
        >
          <svgicon
            icon="spinner"
            v-if="deleteExtraChargeLoader"
            class="button__loader_red"
          ></svgicon>
          Delete
        </button>
      </div>
    </AppModal>

    <!-- Date manage subscription modal -->
    <AppModal
      :show="dateModal"
      :showOkButton="true"
      okButtonText="Done"
      @onapprove="dateModal = false"
      @onclosed="dateModal = false"
      :styleGotten="{ width: 'auto' }"
    >
      <p class="warning__title">
        Update renewal date
      </p>
      <p class="dashboard__date-header">Select a date</p>
      <v-date-picker v-model="date" is-inline 
      :min-date='new Date()' />
    </AppModal>
    <loader :loader="loader"></loader>
  </div>
</template>

<script>
import {
  getSubscriptionDetail,
  declineExcessCharge,
  approveExcessCharge,
  cancelSub,
  markExtraChargePaid,
  getSetup,
  addExtraCharge,
  editExtraCharge,
  deleteExtraCharge,
  reactivateSub
} from "../../../services/subscription";
import { uploadFile, folderNames } from "../../../services/fileUpload";
import { formatReadbleDate, formatCurrencyAmount } from "../../utils";
import AppModal from "../resuables/modal";
import loader from "../resuables/loader";
import moment from "moment";
let Gmap;
let Gmarker;
export default {
  name: "subscriptionDetail",
  components: {
    AppModal,
    loader
  },
  data() {
    return {
      profileImage:
        "https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80",
      showPricingBreakdownModal: false,
      showCancelSubWarningModal: false,
      showReactivateModal: false,
      showMarkExtraPaidWarningModal: false,
      showMapModal: false,
      latitude: 6.437145599999999,
      longitude: 3.484465699999999,
      search: "",
      showRetractionModal: false,
      retractionReason: "",
      subscriptionId: "",
      subscriptionData: null,
      dropdownLoader: false,
      loader: false,
      showExcessChargeWarning: false,
      excessChargeId: null,
      declineAction: false,
      approveAction: false,
      reason: null,
      showDeclineOptionModal: false,
      extraChargeLoader: false,
      extraChargeData: {
        amount: null,
        extracharge_type: null,
        narration: null,
        member_id: null,
        subscription_id: null,
        doc_file_path: null
      },
      editExtraCharge: false,
      extraChargeId: null,
      showExtraChargeModal: false,
      subscriptionSetup: {},
      showExtraChargeWarningModal: false,
      document: null,
      showDeleteExtraChargeModal: false,
      deleteExtraChargeReason: null,
      deleteExtraChargeLoader: false,
      date: new Date(),
      manageSubscription: false,
      manageLoader: false,
      dateModal: false,
      manageSubForm: {
        sub_plan: null,
        security_days: null,
        security_deposit_bal: null,
        end_date: null
      },
      reactivateLoader: false
    };
  },
  methods: {
    toggleDeleteExtraChargeModal(id) {
      this.showDeleteExtraChargeModal = !this.showDeleteExtraChargeModal;
      this.extraChargeId = id;
    },
    deleteExtraCharge() {
      this.deleteExtraChargeLoader = true;
      let payload = {
        otherReason: this.deleteExtraChargeReason
      };
      deleteExtraCharge(payload, this.extraChargeId)
        .then(data => {
          this.deleteExtraChargeLoader = false;
          if (data.statusCode === 200) {
            this.deleteExtraChargeReason = null;
            this.extraChargeId = null;
            this.showDeleteExtraChargeModal = false;
            this.getSubscriptionDetail(this.subscriptionId);
            this.$notification.success({
              message: "Extra charge deleted",
              description: "You have successfully delete extra charge!"
            });
          } else {
            this.deleteExtraChargeReason = null;
            this.extraChargeId = null;
            this.showDeleteExtraChargeModal = false;
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.deleteExtraChargeLoader = false;
          this.deleteExtraChargeReason = null;
          this.extraChargeId = null;
          this.showDeleteExtraChargeModal = false;
          this.$notification.error({
            message: "Error!",
            description: err.response.data.message
          });
          return err;
        });
    },
    async addExtracharge() {
      this.loader = true;
      if (!this.editExtraCharge) {
        this.toggleExtraChargeWarningModal();
        try {
          this.extraChargeLoader = true;
          const result = await uploadFile(
            this.document,
            folderNames.docs.extracharge
          );
          this.extraChargeData.member_id = this.subscriptionData.user_id;
          this.extraChargeData.subscription_id = this.subscriptionId;
          this.extraChargeData.doc_file_path = result.data.secure_url;
          const data = await addExtraCharge(this.extraChargeData);
          this.getSubscriptionDetail(this.subscriptionId);
          this.document = null;
          this.loader = false;
          this.$notification.success({
            message: "Extra charge successful",
            description: "Extra charge was added successfully!"
          });

          this.extraChargeLoader = false;
        } catch (err) {
          this.loader = false;
          this.extraChargeLoader = false;
          this.$notification.error({
            message: "Extra charge error",
            description: err.response.data.message
          });
        }
      } else {
        try {
          if (this.document) {
            const result = await uploadFile(
              this.document,
              folderNames.docs.extracharge
            );
            this.extraChargeData.doc_file_path = result.data.secure_url;
          }
          let extraChargeData = {
            amount: this.extraChargeData.amount,
            subscription_id: this.extraChargeData.subscription_id,
            extracharge_type: this.extraChargeData.extracharge_type,
            doc_file_path: this.extraChargeData.doc_file_path,
            narration: this.extraChargeData.narration
          };
          const data = await editExtraCharge(
            extraChargeData,
            this.extraChargeId
          );
          this.toggleExtraChargeWarningModal();
          this.getSubscriptionDetail(this.subscriptionId);
          this.loader = false;
          this.document = null;
          this.$notification.success({
            message: "Extra charge edited",
            description: "Extra charge was added successfully!"
          });
        } catch (err) {
          this.$notification.error({
            message: "Extra charge error",
            description: "An unexpected error occured. Please try again later"
          });
          this.loader = false;
        }
      }
    },
    toggleExtraChargeModal(id) {
      if (id) {
        this.editExtraCharge = true;
        this.extraChargeId = id;
        this.subscriptionData.extra_charges.find(charge => {
          if (charge.id === id) {
            this.extraChargeData = {
              amount: charge.amount,
              extracharge_type: charge.extracharge_type,
              narration: charge.narration,
              subscription_id: charge.subscription_id,
              doc_file_path: charge.doc_file_path
            };
          }
        });
      } else {
        this.editExtraCharge = false;
        this.extraChargeId = null;
        this.extraChargeData = {
          amount: null,
          extracharge_type: null,
          narration: null,
          member_id: null,
          subscription_id: null,
          doc_file_path: null
        };
      }
      this.document = null;
      this.showExtraChargeModal = !this.showExtraChargeModal;
    },
    docPreUpload(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e => {
        this.document = e.target.result;
      };
    },
    toggleExtraChargeWarningModal() {
      this.showExtraChargeWarningModal = !this.showExtraChargeWarningModal;
      if (this.showExtraChargeModal) {
        this.showExtraChargeModal = false;
      }
    },
    markExtraChargePaid() {
      this.loader = true;
      markExtraChargePaid(this.excessChargeId)
        .then(data => {
          if (data.statusCode === 200) {
            this.loader = false;
            this.$notification.success({
              message: "Success",
              description: "Extra charge marked as paid!"
            });
            this.getSubscriptionDetail(this.subscriptionId);
            this.excessChargeId = null;
            this.showMarkExtraPaidWarningModal = false;
          } else {
            this.loader = false;
            this.showMarkExtraPaidWarningModal = false;
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.loader = false;
          this.showMarkExtraPaidWarningModal = false;
          this.$notification.error({
            message: "Error!",
            description: err.response.data.message
          });
          return err;
        });
    },
    toggleCancelSubWarningModal() {
      this.showCancelSubWarningModal = !this.showCancelSubWarningModal;
    },
    toggleReactivateSubModal() {
      this.showReactivateModal = !this.showReactivateModal;
    },
    toggleRetractionModal(reason) {
      this.showRetractionModal = !this.showRetractionModal;
      this.retractionReason = reason;
    },
    toggleMarkExtraPaidModal(id) {
      this.showMarkExtraPaidWarningModal = !this.showMarkExtraPaidWarningModal;
      this.excessChargeId = id;
    },
    toggleDeclineModal(id) {
      this.showDeclineOptionModal = !this.showDeclineOptionModal;
      this.excessChargeId = id;
    },
    toggleExcessChargeWarningModal(id, action) {
      this.showDeclineOptionModal = false;
      if (action == "decline") {
        this.declineAction = true;
        this.approveAction = false;
      } else if (action == "approve") {
        this.approveAction = true;
        this.declineAction = false;
      }
      this.excessChargeId = id;
      this.showExcessChargeWarning = !this.showExcessChargeWarning;
    },
    togglePricingBreakdownModal() {
      this.showPricingBreakdownModal = !this.showPricingBreakdownModal;
    },
    toggleManageSub() {
      this.manageSubscription = !this.manageSubscription;
    },
    openDateModal() {
      this.dateModal = !this.dateModal;
    },
    formatAttachmentNames(files) {
      if (files.length === 1) {
        return files[0].name;
      } else {
        return `${files.length} files selected`;
      }
    },
    showMap() {
      this.showMapModal = !this.showMapModal;
      const lat = this.latitude;
      const lng = this.longitude;
      const latlng = {
        lat,
        lng
      };
      let mapOptions = {
        center: latlng,
        zoom: 14
      };
      let mapDom = document.getElementById("map");
      Gmap = new google.maps.Map(mapDom, mapOptions);
      this.createMarker();
    },
    createMarker() {
      const lat = this.latitude;
      const lng = this.longitude;
      const latlng = {
        lat,
        lng
      };
      let markerOptions = {
        position: latlng,
        map: Gmap,
        animation: google.maps.Animation.BOUNCE,
        clickable: true,
        draggable: false
      };
      Gmarker = new google.maps.Marker(markerOptions);
    },
    formatDate(data) {
      return formatReadbleDate(data);
    },

    formatAmount(data, currency) {
      return formatCurrencyAmount(data, currency);
    },
    sumRent() {
      return formatCurrencyAmount(
        this.currentPriceTemplate.service_charge +
          this.currentPriceTemplate.rent +
          this.currentPriceTemplate.vat
      );
    },
    async getSubscriptionDetail(id) {
      this.loader = true;
      try {
        let data = await getSubscriptionDetail(id);
        this.subscriptionData = data.data;
        this.loader = false;
      } catch (err) {
        this.loader = false;
        return err;
      }
    },
    cancelSub() {
      cancelSub(this.subscriptionId)
        .then(data => {
          if (data.statusCode == 200) {
            this.showCancelSubWarningModal = false;
            this.$notification.success({
              message: "Subscription Canceled",
              description: "Subscription canceled successfully"
            });
            this.getSubscriptionDetail(this.subscriptionId);
          } else {
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.showCancelSubWarningModal = false;
          this.$notification.error({
            message: "Error!",
            description: err.response.data.message
          });
          return err;
        });
    },
    reactivateSub() {
      this.reactivateLoader = true;
      let payload = {
        status: "active"
      };
      reactivateSub(this.subscriptionId, payload)
        .then(data => {
          if (data.statusCode == 200) {
            this.reactivateLoader = false;
            this.showReactivateModal = false;
            this.$notification.success({
              message: "Subscription Reactivated",
              description: "Subcription reactivated successfully"
            });
            this.getSubscriptionDetail(this.subscriptionId);
          } else {
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.showReactivateModal = false;
          this.reactivateLoader = false;
          this.$notification.error({
            message: "Error!",
            description: err.response.data.message
          });
          return err;
        });
    },

    manageSub() {
      this.manageLoader = true;
      let today = new Date();
      let payload = {};

      if(moment(this.date).format("YYYY-MM-DD") !== moment(today).format("YYYY-MM-DD")){
         payload.end_date = moment(this.date).format("YYYY-MM-DD")
      } 
      if(this.manageSubForm.security_deposit_bal !== null){
        payload.security_deposit_bal = Number(this.manageSubForm.security_deposit_bal);
      }
      if(this.manageSubForm.security_days !== null){
       payload.security_days = Number(this.manageSubForm.security_days);
      }
      if(this.manageSubForm.sub_plan){
        payload.sub_plan = this.manageSubForm.sub_plan;
      }
      reactivateSub(this.subscriptionId, payload)
        .then(data => {
          if (data.statusCode == 200) {
            this.manageLoader = false;
            this.manageSubscription = false;
            this.$notification.success({
              message: "Subscription Updated",
              description: "Subcription updated successfully"
            });
            this.getSubscriptionDetail(this.subscriptionId);
          } else {
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.manageSubscription = false;
          this.manageLoader = false;
          this.$notification.error({
            message: "Error!",
            description: err.response.data.message
          });
          return err;
        });
    },
    declineExcessCharge() {
      this.loader = true;
      let data = {
        reason: this.reason
      };
      declineExcessCharge(this.excessChargeId, data)
        .then(data => {
          this.reason = null;
          this.loader = false;
          this.showExcessChargeWarning = false;
          if (data.statusCode == 200) {
            this.$notification.success({
              message: "Excess charge declined",
              description: "Excess charge declined successfully"
            });
            this.getSubscriptionDetail(this.subscriptionId);
          } else {
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.loader = false;
          this.showExcessChargeWarning = false;
          this.reason = null;
          this.$notification.error({
            message: "Error",
            description: err.response.data.message
          });
          return err;
        });
    },
    approveExcessCharge() {
      this.loader = true;
      approveExcessCharge(this.excessChargeId)
        .then(data => {
          this.loader = false;
          this.showExcessChargeWarning = false;
          if (data.statusCode == 200) {
            this.$notification.success({
              message: "Excess charge approved",
              description: "Excess charge approved successfully"
            });
            this.getSubscriptionDetail(this.subscriptionId);
          } else {
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.loader = false;
          this.showExcessChargeWarning = false;
          this.$notification.error({
            message: "Error!",
            description: err.response.data.message
          });
          return err;
        });
    },
    excessAction() {
      if (this.declineAction) {
        this.declineExcessCharge();
      } else if (this.approveAction) {
        this.approveExcessCharge();
      }
    },
    async getSubscriptionSetup() {
      const res = await getSetup();
      this.subscriptionSetup = { ...res.data };
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatNowDate(value) {
      if (!value) return "";
      if (value) {
        return moment(value).fromNow();
      }
    },
    capitalizeFirstLetter(value) {
      if (!value) return "";
      if (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    }
  },
  computed: {
    getPages() {
      return this.$route.query.page || 0;
    },
    curPage() {
      return this.$route.query.currentPage || 1;
    },
    currentPriceTemplate() {
      if (this.subscriptionData) {
        return this.subscriptionData.price;
      } else {
        return {};
      }
    },
    totalRent() {
      let rent = formatCurrencyAmount(
        +this.currentPriceTemplate.service_charge +
          +this.currentPriceTemplate.amount +
          +this.currentPriceTemplate.withholdingTax +
          +this.currentPriceTemplate.vat +
          +this.currentPriceTemplate.computed_commission -
          +this.currentPriceTemplate.discount,
        this.currentPriceTemplate.currency
      );
      return rent;
    },
    sortExtraCharge() {
      if (this.subscriptionData && this.subscriptionData.extra_charges) {
        return this.subscriptionData.extra_charges
          .filter(el => el.status !== "Deleted")
          .sort(
            (d1, d2) =>
              new Date(d2.updated_at).getTime() -
              new Date(d1.updated_at).getTime()
          );
      }
    },
    currency() {
      return {
        prefix: `${
          this.currentPriceTemplate &&
          this.currentPriceTemplate.currency === "GHS"
            ? "¢ "
            : "₦ "
        }`,
        numeral: true,
        numeralPositiveOnly: true,
        noImmediatePrefix: true,
        rawValueTrimPrefix: true,
        numeralIntegerScale: 9,
        numeralDecimalScale: 2
      };
    }
  },
  async mounted() {
    const { id } = this.$route.params;
    this.subscriptionId = atob(id);
    this.getSubscriptionSetup();
    await this.getSubscriptionDetail(this.subscriptionId);
  }
};
</script>

<style lang="scss" scoped>
.extraChargeReceipt {
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.full__width {
  width: 100% !important;
}
.btn_disabled {
  &:focus {
    outline: none;
  }
  &:disabled {
    cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/subscriptionDetails.vue